// components/LeftPanel.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatDate, formatDay, calculateRemainingDays } from "utils/helpers";
import FileView from "components/fileView";
import { LoadingIcon } from "utils/constant";
import ShowUI, { CanShow, LEGISLATIVE_DRAFTING_UI_RULES } from "utils/authRules";
import { useToast } from "contexts/ToastContext";
import { LAW_IMPLEMENTATION_REQUEST_STATUS, LEGAL_ADVISORY_REQUEST_STATUS, LEGAL_AWAERENESS_REQUEST_STATUS } from "utils/constantValues";
import HeadRemark from "./headRemark";
import DirectorRemark from "./directorRemark";
import CoordinatorRemark from "./coordinatorRemark";
import ProsecutorRemark from "./prosecutorRemark";
import ActionAvatars from "pages/conductLegalResearch/fragments/actionAvatars";
import PublicFeedback from "./publicFeedback";
import UploadAmendedFile from "./uploadAmendedFile";
import DynamicFormInput from "components/form/form";
import { useAuth } from "contexts/AuthContext";
import { StatusChip } from "components/StatusChip";
import RespondBackForm from "pages/conductLegalResearch/fragments/respondBackform";
import LegislativeRespondBackForm from "./LegislativeResponback";
import { updateLegalAdvisory } from "services/legalAdvisoryService";
import TeamView from "components/team_view";
import EditTeamModal from "./editTeamModal";
import { updateLawImplementation } from "services/lawImplementationService";
import { updateLegalAwareness, updateLegalAwarenessSchedule } from "services/legalAwarenessService";
import CoordinatorCreateRequest from "pages/conductLegalResearch/coordinatorCreateRequest";
import DocumentViewerModal from "components/DocumentViewer";
import ConfirmationModal from "components/ConfirmationModal1";
import Button from "components/ui/Button";
import TabNav from "components/TabNav";
import { useTranslation } from "react-i18next";

function LegalAwarenessCreationDetail({ request }: { request: any }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [publicFeedback, setPublicFeedback] = useState(false);
    const [uploadAmend, setUploadAmend] = useState(false);
    const [auditDraft, setAuditDraft] = useState(false);
    const [showDraftHistory, setShowDraftHistory] = useState(false);
    const [viewTeam, setViewTeam] = useState(false);
    const [editTeamOpen, setEditTeamOpen] = useState(false);
    const [edit, setEdit] = useState(false);
    const [formState, setFormState] = useState({ ...request });
    const contextData = useAuth();
    const { showToast } = useToast();

    const [isRespondBackFormOpen, setIsRespondBackFormOpen] = useState(false);
    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
    const [pendingForwardStatus, setPendingForwardStatus] = useState<string | null>(null);
    const [activeTab, setActiveTab] = useState<string>('');
    const [editSchedule, setEditSchedule] = useState(false);

    const handleUpdateSchedule = async () => {
        setLoading(true);
        try {
            const data = new FormData();
            data.append("location", formState.legal_awarness_schedules[0].location);
            data.append("scheduled_datetime", formState.legal_awarness_schedules[0].scheduled_datetime);
            
            const response = await updateLegalAwarenessSchedule(formState.legal_awarness_schedules[0].id, data);
            
            setFormState((prev: any) => ({
                ...prev,
                legal_awarness_schedules: prev.legal_awarness_schedules.map((schedule: any) => 
                    schedule.id === response.id ? response : schedule
                )
            }));
            
            showToast(t("SeminarScheduleUpdatedSuccess") || "Seminar Schedule updated successfully!", "success");
            setEditSchedule(false);
        } catch (error) {
            console.error("Error updating schedule:", error);
            showToast(t("FailedToUpdateSeminarSchedule") || "Failed to update Seminar Schedule.", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleFileChange = (
        file: any,
        fieldName: keyof typeof formState
    ) => {
        setFormState((prev: any) => ({
            ...prev,
            [fieldName]: file,
        }));
    };

    const handleUpdateSummary = async () => {
        setLoading(true);
        const data = new FormData();
        data.append("summary", formState.summary);
        if (formState.legal_awareness_document_file) {
            data.append("document_files", formState.legal_awareness_document_file);
        }

        try {
            const response = await updateLegalAwareness(formState.id, data);
            setFormState((prev: any) => ({ ...prev, ...response }));
            showToast(t("LegalAwarenessSummaryUpdated") || "Legal Awareness Summary updated successfully!", "success");
            setEdit(false);
        } catch (error) {
            console.error("Error updating summary:", error);
            showToast(t("FailedToUpdateLegalAwarenessSummary") || "Failed to update Legal Awareness Summary.", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (
        e: React.ChangeEvent<
            HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
        >
    ) => {
        const { name, value } = e.target;
        setFormState((prev: any) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleRespondBackClick = () => {
        setIsRespondBackFormOpen(!isRespondBackFormOpen);
    }

    const handleForwardClick = (status: string) => {
        setPendingForwardStatus(status);
        setConfirmationModalOpen(true);
    };

    const handleConfirmForward = () => {
        if (pendingForwardStatus) {
            handleForward(pendingForwardStatus);
        }
        setConfirmationModalOpen(false);
        setPendingForwardStatus(null);
    };

    const handleAdditionalInfoApprove = async () => {
        setLoading(true);
        const data = new FormData();

        data.append("forward_status", LEGAL_ADVISORY_REQUEST_STATUS.forwarded_to_registrar.value);

        try {
            const response = await updateLawImplementation(formState.id, data);

            setFormState((prev: any) => ({ ...prev, ...response }));
            showToast(t("ProposalApprovedSuccess") || "Legal research proposal Approved!", "success");
        } catch (error) {
            console.error("Error submitting request:", error);
            showToast(t("FailedToUpdateApproval") || "Failed to update legal research proposal Approval.", "error");
        } finally {
            setLoading(false);
        }
    }

    const handleReject = () => {
    }

    const handleForward = async (froward_status: string) => {
        setLoading(true);
        const data = new FormData();
        if (froward_status === LEGAL_AWAERENESS_REQUEST_STATUS.summary_approved.value) {
            data.append(
                "current_approval_status",
                froward_status
            );

            try {
                const response = await updateLegalAwareness(formState.id, data);

                setFormState((prev: any) => ({ ...prev, ...response }));
                showToast(t("LegalAwarenessForwardedSuccess") || "Legal Awareness Forwarded successfully!", "success");
            } catch (error) {
                console.error("Error submitting request:", error);
                showToast(t("FailedToUpdateLegalAwarenessRequest") || "Failed to update Legal Awareness request.", "error");
            } finally {
                setLoading(false);
            }
            return;
        }

        data.append(
            "forward_status",
            froward_status
        );

        try {
            const response = await updateLegalAwareness(formState.id, data);

            setFormState((prev: any) => ({ ...prev, ...response }));
            showToast(t("LegalAwarenessForwardedSuccess") || "Legal Awareness Forwarded successfully!", "success");
        } catch (error) {
            console.error("Error submitting request:", error);
            showToast(t("FailedToUpdateLegalAwarenessRequest") || "Failed to update Legal Awareness request.", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleAudit = async () => {
        setLoading(true);
        const data = new FormData();
        data.append("audit_summary", formState.audit_summary);
        data.append("audit_summary_file", formState.audit_summary_file);
        data.append("status", LEGAL_ADVISORY_REQUEST_STATUS.audit_submitted.value);

        try {
            const response = await updateLawImplementation(formState.id, data);

            setFormState((prev: any) => ({ ...prev, ...response }));
            showToast(t("LegislativeDraftForwardedSuccess") || "Legislative Draft Forwarded successfully!", "success");
        } catch (error) {
            console.error("Error submitting request:", error);
            showToast(t("FailedToUpdateLegislativeDraftRequest") || "Failed to update Legislative Draft request.", "error");
        } finally {
            setLoading(false);
            setAuditDraft(false);
        }
    };

    const handlePublish = async () => {
        setLoading(true);
        const data = new FormData();
        data.append("status", LEGAL_ADVISORY_REQUEST_STATUS.published.value);
        data.append("forward_status", LEGAL_ADVISORY_REQUEST_STATUS.not_forwarded.value);

        try {
            const response = await updateLawImplementation(formState.id, data);

            setFormState((prev: any) => ({ ...prev, ...response }));
            showToast(t("LegislativeDraftForwardedSuccess") || "Legislative Draft Forwarded successfully!", "success");
        } catch (error) {
            console.error("Error submitting request:", error);
            showToast(t("FailedToUpdateLegislativeDraftRequest") || "Failed to update Legislative Draft request.", "error");
        } finally {
            setLoading(false);
            setAuditDraft(false);
        }
    };

    const handleDraftApprove = async () => {
        setLoading(true);
        const data = new FormData();
        if (formState.current_approval_status === "identification_in_progress") {
            data.append(
                "current_approval_status",
                LAW_IMPLEMENTATION_REQUEST_STATUS.identification_complete.value
            );
            data.append("forward_status", LEGAL_ADVISORY_REQUEST_STATUS.assigned_to_prosecutor.value);
        }
        else if (formState.current_approval_status === "proposal_submitted") {
            data.append(
                "current_approval_status",
                LAW_IMPLEMENTATION_REQUEST_STATUS.audit_in_progress.value
            );
            data.append("forward_status", LEGAL_ADVISORY_REQUEST_STATUS.assigned_to_prosecutor.value);
        }
        else if (formState.current_approval_status === "audit_completed") {
            data.append(
                "current_approval_status",
                LAW_IMPLEMENTATION_REQUEST_STATUS.finalization_complete.value
            );
            data.append("forward_status", LEGAL_ADVISORY_REQUEST_STATUS.forwarded_to_registrar.value);
        }
        else {
            data.append("status", LEGAL_ADVISORY_REQUEST_STATUS.draft_approved.value);
            data.append("forward_status", LEGAL_ADVISORY_REQUEST_STATUS.forwarded_to_registrar.value);
        }

        try {
            const response = await updateLawImplementation(formState.id, data);

            setFormState((prev: any) => ({ ...prev, ...response }));
            showToast(t("LegislativeDraftForwardedSuccess") || "Legislative Draft Forwarded successfully!", "success");
        } catch (error) {
            console.error("Error submitting request:", error);
            showToast(t("FailedToUpdateLegislativeDraftRequest") || "Failed to update Legislative Draft request.", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleFinalApprove = async () => {
        setLoading(true);
        const data = new FormData();
        data.append("status", LEGAL_ADVISORY_REQUEST_STATUS.final_approval.value);

        try {
            const response = await updateLawImplementation(formState.id, data);

            setFormState((prev: any) => ({ ...prev, ...response }));
            showToast(t("LegislativeDraftForwardedSuccess") || "Legislative Draft Forwarded successfully!", "success");
        } catch (error) {
            console.error("Error submitting request:", error);
            showToast(t("FailedToUpdateLegislativeDraftRequest") || "Failed to update Legislative Draft request.", "error");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { console.log("formState: ", formState) }, [formState]);
    useEffect(() => {
        if (formState?.distrbuted_to_zone?.length > 0 && !activeTab) {
            setActiveTab(formState.distrbuted_to_zone[0].admin_unit_name);
        }
    }, [formState.distrbuted_to_zone, activeTab]);

    return (
        <div className="flex-1 bg-gray-100 mx-4 rounded-lg overflow-y-scroll scrollbar-hide">
            <div className="flex flex-col max-w-4xl bg-white rounded-lg shadow-md p-6">
                {/* Header */}
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between pb-4 mb-3 space-y-4 lg:space-y-0">
                    <div className="flex flex-col sm:flex-row sm:items-center space-y-2 sm:space-y-0 sm:space-x-3">
                        <button
                            onClick={() => navigate("/legal-awareness-creation")}
                            className="text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded p-2 self-start transition-colors"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M15 19l-7-7 7-7"
                                />
                            </svg>
                        </button>
                        <h1 className="text-xl lg:text-2xl font-bold text-[#9D0303]">{t("LegalAwarenessCreation") || "Legal Awareness Creation"}</h1>
                        <div className="flex space-x-2">
                            <span className="bg-yellow-100 text-yellow-800 text-xs px-2 py-1 rounded-full font-medium">
                                {formState.current_approval_status}
                            </span>
                            <span className="bg-gray-100 text-gray-600 text-xs px-2 py-1 rounded-full font-medium">
                                {formState.forward_status}
                            </span>
                        </div>
                    </div>
                    <div className="flex flex-wrap gap-4 lg:ml-auto lg:justify-end">
                        <ShowUI
                            ui_key={LEGISLATIVE_DRAFTING_UI_RULES.registrar_forward_to_coordinator.value}
                            currentStatus={formState.current_approval_status}
                            forwardStatus={formState.forward_status}
                        >
                            <Button
                                variant="success"
                                size="lg"
                                onClick={() => handleForwardClick(LEGAL_ADVISORY_REQUEST_STATUS.forwarded_to_coordinator.value)}
                            >
                                {t("Forward") || "Forward"}
                            </Button>
                        </ShowUI>
                        <ShowUI
                            ui_key={LEGISLATIVE_DRAFTING_UI_RULES.stakeholder_forward_to_head.value}
                            currentStatus={formState.current_approval_status}
                            forwardStatus={formState.forward_status}
                        >
                            <div className="flex gap-4">
                                <div onClick={() => navigate("/legal-advisory/request", { state: { request: formState } })} className="px-2 hover:bg-gray-100 rounded-lg cursor-pointer">
                                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.66406 21V16.75L16.8641 3.575C17.0641 3.39167 17.2851 3.25 17.5271 3.15C17.7691 3.05 18.0231 3 18.2891 3C18.5551 3 18.8134 3.05 19.0641 3.15C19.3147 3.25 19.5314 3.4 19.7141 3.6L21.0891 5C21.2891 5.18333 21.4351 5.4 21.5271 5.65C21.6191 5.9 21.6647 6.15 21.6641 6.4C21.6641 6.66667 21.6184 6.921 21.5271 7.163C21.4357 7.405 21.2897 7.62567 21.0891 7.825L7.91406 21H3.66406ZM18.2641 7.8L19.6641 6.4L18.2641 5L16.8641 6.4L18.2641 7.8Z" fill="black" />
                                    </svg>
                                </div>
                                <Button
                                    variant="success"
                                    size="lg"
                                    onClick={() => handleForwardClick(LEGAL_ADVISORY_REQUEST_STATUS.forwarded_to_head.value)}
                                >
                                    {t("Forward") || "Forward"}
                                </Button>
                            </div>
                        </ShowUI>
                        <ShowUI
                            ui_key={LEGISLATIVE_DRAFTING_UI_RULES.head_forward_to_prosecutor.value}
                            currentStatus={formState.current_approval_status}
                            forwardStatus={formState.forward_status}
                        >
                            <Button
                                variant="success"
                                size="lg"
                                onClick={() => handleForwardClick(LEGAL_ADVISORY_REQUEST_STATUS.assigned_to_prosecutor.value)}
                            >
                                {t("Forward") || "Forward"}
                            </Button>
                        </ShowUI>
                        <ShowUI
                            ui_key={LEGISLATIVE_DRAFTING_UI_RULES.head_forward_to_director.value}
                            currentStatus={formState.current_approval_status}
                            forwardStatus={formState.forward_status}
                        >
                            <div className="flex gap-4">
                                <ShowUI
                                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.edit_head_forward_to_director.value}
                                    currentStatus={formState.current_approval_status}
                                    forwardStatus={formState.forward_status}
                                >
                                    <div onClick={() => setEdit(!edit)} className="px-2 hover:bg-gray-100 rounded-lg cursor-pointer">
                                        {edit ?
                                            <p>{t("Cancel") || "Cancel"}</p> :
                                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.66406 21V16.75L16.8641 3.575C17.0641 3.39167 17.2851 3.25 17.5271 3.15C17.7691 3.05 18.0231 3 18.2891 3C18.5551 3 18.8134 3.05 19.0641 3.15C19.3147 3.25 19.5314 3.4 19.7141 3.6L21.0891 5C21.2891 5.18333 21.4351 5.4 21.5271 5.65C21.6191 5.9 21.6647 6.15 21.6641 6.4C21.6641 6.66667 21.6184 6.921 21.5271 7.163C21.4357 7.405 21.2897 7.62567 21.0891 7.825L7.91406 21H3.66406ZM18.2641 7.8L19.6641 6.4L18.2641 5L16.8641 6.4L18.2641 7.8Z" fill="black" />
                                            </svg>}
                                    </div>
                                </ShowUI>
                                <Button
                                    variant="success"
                                    size="lg"
                                    onClick={() => handleForwardClick(
                                        formState.current_approval_status === LEGAL_ADVISORY_REQUEST_STATUS.under_review.value ? LEGAL_ADVISORY_REQUEST_STATUS.not_forwarded.value :
                                            LEGAL_ADVISORY_REQUEST_STATUS.forwarded_to_director.value)}
                                >
                                    {t("Forward") || "Forward"}
                                </Button>
                            </div>
                        </ShowUI>
                        <ShowUI
                            ui_key={LEGISLATIVE_DRAFTING_UI_RULES.director_forward_to_coordinator.value}
                            currentStatus={formState.current_approval_status}
                            forwardStatus={formState.forward_status}
                        >
                            <div className="flex gap-4">
                                <div onClick={() => setEdit(!edit)} className="px-2 hover:bg-gray-100 rounded-lg cursor-pointer">
                                    {edit ?
                                        <p>{t("Cancel") || "Cancel"}</p> :
                                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.66406 21V16.75L16.8641 3.575C17.0641 3.39167 17.2851 3.25 17.5271 3.15C17.7691 3.05 18.0231 3 18.2891 3C18.5551 3 18.8134 3.05 19.0641 3.15C19.3147 3.25 19.5314 3.4 19.7141 3.6L21.0891 5C21.2891 5.18333 21.4351 5.4 21.5271 5.65C21.6191 5.9 21.6647 6.15 21.6641 6.4C21.6641 6.66667 21.6184 6.921 21.5271 7.163C21.4357 7.405 21.2897 7.62567 21.0891 7.825L7.91406 21H3.66406ZM18.2641 7.8L19.6641 6.4L18.2641 5L16.8641 6.4L18.2641 7.8Z" fill="black" />
                                        </svg>}
                                </div>
                                <Button
                                    variant="success"
                                    size="lg"
                                    onClick={() => handleForwardClick(
                                        formState.current_approval_status === LEGAL_ADVISORY_REQUEST_STATUS.back_to_head.value ? LEGAL_ADVISORY_REQUEST_STATUS.forwarded_to_head.value :
                                            LEGAL_ADVISORY_REQUEST_STATUS.forwarded_to_coordinator.value)}
                                >
                                    {t("Forward") || "Forward"}
                                </Button>
                            </div>
                        </ShowUI>
                        <ShowUI
                            ui_key={LEGISLATIVE_DRAFTING_UI_RULES.coordinator_forward_to_prosecutor.value}
                            currentStatus={formState.current_approval_status}
                            forwardStatus={formState.forward_status}
                        >
                            <div className="flex gap-4">
                                <ShowUI
                                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.edit_coordinator_forward_to_prosecutor.value}
                                    currentStatus={formState.current_approval_status}
                                    forwardStatus={formState.forward_status}
                                >
                                    <div onClick={() => setEdit(!edit)} className="px-2 hover:bg-gray-100 rounded-lg cursor-pointer">
                                        {edit ?
                                            <p>{t("Cancel") || "Cancel"}</p> :
                                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.66406 21V16.75L16.8641 3.575C17.0641 3.39167 17.2851 3.25 17.5271 3.15C17.7691 3.05 18.0231 3 18.2891 3C18.5551 3 18.8134 3.05 19.0641 3.15C19.3147 3.25 19.5314 3.4 19.7141 3.6L21.0891 5C21.2891 5.18333 21.4351 5.4 21.5271 5.65C21.6191 5.9 21.6647 6.15 21.6641 6.4C21.6641 6.66667 21.6184 6.921 21.5271 7.163C21.4357 7.405 21.2897 7.62567 21.0891 7.825L7.91406 21H3.66406ZM18.2641 7.8L19.6641 6.4L18.2641 5L16.8641 6.4L18.2641 7.8Z" fill="black" />
                                            </svg>}
                                    </div>
                                </ShowUI>
                                <Button
                                    variant="success"
                                    size="lg"
                                    onClick={() => handleForwardClick(
                                        formState.current_approval_status === LEGAL_ADVISORY_REQUEST_STATUS.back_to_director.value ? LEGAL_ADVISORY_REQUEST_STATUS.forwarded_to_coordinator.value :
                                            LEGAL_ADVISORY_REQUEST_STATUS.assigned_to_prosecutor.value)}
                                >
                                    {t("Forward") || "Forward"}
                                </Button>
                            </div>
                        </ShowUI>
                        <ShowUI
                            ui_key={LEGISLATIVE_DRAFTING_UI_RULES.coordinator_forward_to_head.value}
                            currentStatus={formState.current_approval_status}
                            forwardStatus={formState.forward_status}
                        >
                            <button onClick={() => handleForwardClick(LEGAL_ADVISORY_REQUEST_STATUS.forwarded_to_head.value)} type="button" className="bg-[#212121] text-white rounded-lg px-6">
                                {t("Forward") || "Forward"}
                            </button>
                        </ShowUI>
                        <ShowUI
                            ui_key={LEGISLATIVE_DRAFTING_UI_RULES.additional_info_action.value}
                            currentStatus={formState.current_approval_status}
                            forwardStatus={formState.forward_status}
                        >
                            <button onClick={() => handleForwardClick(LEGAL_ADVISORY_REQUEST_STATUS.forwarded_to_registrar.value)} type="button" className="bg-[#212121] text-white rounded-lg px-6">
                                {t("Forward") || "Forward"}
                            </button>
                        </ShowUI>
                        <ShowUI
                            ui_key={LEGISLATIVE_DRAFTING_UI_RULES.prosecutor_forward_to_coordinator.value}
                            currentStatus={formState.current_approval_status}
                            forwardStatus={formState.forward_status}
                        >
                            <button onClick={() => handleForwardClick(LEGAL_ADVISORY_REQUEST_STATUS.forwarded_to_coordinator.value)} type="button" className="bg-[#212121] text-white rounded-lg px-6">
                                {t("Forward") || "Forward"}
                            </button>
                        </ShowUI>
                        <ShowUI
                            ui_key={LEGISLATIVE_DRAFTING_UI_RULES.identification_complete_forward.value}
                            currentStatus={formState.current_approval_status}
                            forwardStatus={formState.forward_status}
                        >
                            <button onClick={() => handleForwardClick(LEGAL_ADVISORY_REQUEST_STATUS.forwarded_to_coordinator.value)} type="button" className="bg-[#212121] text-white rounded-lg px-6">
                                {t("IdentificationCompleted") || "Identification Completed"}
                            </button>
                        </ShowUI>
                    </div>
                </div>
                
                <ShowUI
                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.publish.value}
                    currentStatus={formState.current_approval_status}
                    forwardStatus={formState.forward_status}
                >
                    <div className="flex mb-4">
                        <button onClick={handlePublish} className="p-4 flex-1 bg-[#212121] text-white rounded-lg">
                            {t("BroadcastToPublicWebsite") || "Broadcast to Public Website"}
                        </button>
                    </div>
                </ShowUI>
                
                <ShowUI
                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.broadcasted.value}
                    currentStatus={formState.current_approval_status}
                    forwardStatus={formState.forward_status}
                >
                    <div className="flex mb-4">
                        <button className="p-4 flex-1 bg-[#212121] text-white rounded-lg">
                            {t("Broadcasted") || "Broadcasted"}
                        </button>
                    </div>
                </ShowUI>
                
                {formState?.legal_request_advice_file &&
                    <div className="flex-1 bg-white mb-4 p-4 rounded-lg border border-gray-400">
                        <div className="pb-2 border-b border-gray-200 mb-4">
                            <p>{t("SummaryWritten") || "Summary Written"}</p>
                        </div>
                        <p className="text-[#747171] font-normal text-xs mb-3">{formatDay(formState?.created_at).rest}</p>
                        <p className="font-regular text-base text-[#606060]">{formState?.legal_request_advice_summary}</p>
                        <div className="flex border border-gray-200 p-2 rounded-lg my-4">
                            <FileView title={t("DraftLawFile") || "Draft Law File"} file={formState?.legal_request_advice_file} />
                        </div>
                    </div>}
                
                <ShowUI
                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.final_approval.value}
                    currentStatus={formState.current_approval_status}
                    forwardStatus={formState.forward_status}
                >
                    <LegislativeRespondBackForm
                        request={formState}
                        setLegalResearch={setFormState}
                        isOpen={isRespondBackFormOpen}
                        onClose={() => setIsRespondBackFormOpen(false)}
                        forward={LEGAL_ADVISORY_REQUEST_STATUS.audit_responded.value}
                    />
                    <div className="flex gap-4">
                        <button onClick={handleRespondBackClick} className="p-4 flex-1 bg-[#D4D4D4] text-[#212121] rounded-lg">
                            {t("RespondBack") || "Respond Back"}
                        </button>
                        <button onClick={handleFinalApprove} className="p-4 flex-1 bg-[#212121] text-white rounded-lg">
                            {t("FinalApproveDraftLaw") || "Final Approve Draft Law"}
                        </button>
                    </div>
                </ShowUI>
                
                <ShowUI
                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.edit_head_forward_to_director.value}
                    currentStatus={formState.current_approval_status}
                    forwardStatus={formState.forward_status}
                >
                    <HeadRemark type="legal" setEdit={setEdit} setFormState={setFormState} formState={formState} />
                </ShowUI>
                
                <ShowUI
                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.edit_director_forward_to_coordinator.value}
                    currentStatus={formState.current_approval_status}
                    forwardStatus={formState.forward_status}
                >
                    <DirectorRemark type="legal" setEdit={setEdit} setFormState={setFormState} formState={formState} />
                </ShowUI>
                
                {/* Seminar Schedule Section */}
                {formState?.legal_awarness_schedules?.length > 0 &&
                    <div className="border border-gray-200 shadow-sm rounded-xl mb-4 overflow-hidden">
                        <div className="bg-gradient-to-r from-[#0A1D39] to-[#13294d] px-5 py-3 flex justify-between items-center">
                            <div className="flex items-center gap-3">
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7 text-amber-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                <div>
                                    <p className="text-[10px] uppercase tracking-widest text-amber-300 font-semibold">{t("OAG") || "OAG"}</p>
                                    <p className="text-white font-semibold text-base">{t("SeminarSchedule") || "Seminar Schedule"}</p>
                                </div>
                            </div>
                            {contextData?.user?.roles?.some((p) => p === "LegalResearchCoordinator") && (
                                <button type="button" onClick={() => setEditSchedule(!editSchedule)} className="text-sm text-white/90 hover:text-white flex items-center gap-1">
                                    {editSchedule ?
                                        (t("Cancel") || "Cancel") :
                                        <>
                                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.66406 21V16.75L16.8641 3.575C17.0641 3.39167 17.2851 3.25 17.5271 3.15C17.7691 3.05 18.0231 3 18.2891 3C18.5551 3 18.8134 3.05 19.0641 3.15C19.3147 3.25 19.5314 3.4 19.7141 3.6L21.0891 5C21.2891 5.18333 21.4351 5.4 21.5271 5.65C21.6191 5.9 21.6647 6.15 21.6641 6.4C21.6641 6.66667 21.6184 6.921 21.5271 7.163C21.4357 7.405 21.2897 7.62567 21.0891 7.825L7.91406 21H3.66406ZM18.2641 7.8L19.6641 6.4L18.2641 5L16.8641 6.4L18.2641 7.8Z" fill="#ffffff" />
                                            </svg>
                                            {t("Edit") || "Edit"}
                                        </>
                                    }
                                </button>
                            )}
                        </div>
                        <div className="px-5 py-4">
                        <div className="flex flex-wrap justify-between items-center gap-3 mb-1">
                            <div>
                                <p className="text-xs uppercase tracking-wide text-gray-400 font-semibold">{t("Location") || "Location"}</p>
                                <p className="text-sm text-[#0A1D39] font-medium">{formState.legal_awarness_schedules?.[0]?.location || "—"}</p>
                            </div>
                            <div className="text-right">
                                <p className="text-xs uppercase tracking-wide text-gray-400 font-semibold">{t("ScheduledDateTime") || "Scheduled Date & Time"}</p>
                                <p className="text-sm text-[#0A1D39] font-medium">
                                    {formatDay(formState.legal_awarness_schedules?.[0]?.scheduled_datetime)?.weekday}, {formatDay(formState.legal_awarness_schedules?.[0]?.scheduled_datetime)?.rest}
                                </p>
                            </div>
                            {(() => {
                                const remaining = calculateRemainingDays(formState.legal_awarness_schedules?.[0]?.scheduled_datetime);
                                const badgeClass = remaining > 3
                                    ? "bg-green-100 text-green-800"
                                    : remaining >= 0
                                        ? "bg-amber-100 text-amber-800"
                                        : "bg-red-100 text-red-800";
                                return (
                                    <span className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold ${badgeClass}`}>
                                        <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                        {remaining > 0
                                            ? `${remaining} ${t("DaysRemaining") || "days remaining"}`
                                            : remaining === 0
                                                ? (t("Today") || "Today")
                                                : `${Math.abs(remaining)} ${t("DaysAgo") || "days ago"}`}
                                    </span>
                                );
                            })()}
                        </div>

                        {/* Edit form for schedule */}
                        {editSchedule && contextData?.user?.roles?.some((p) => p === "LegalResearchCoordinator") && (
                            <div className="mt-4 p-4 border border-gray-200 rounded-lg">
                                <div className="mb-4">
                                    <label className="text-gray-500 font-normal text-sm">
                                        {t("Location") || "Location"}
                                    </label>
                                    <input
                                        type="text"
                                        name="location"
                                        className="w-full mt-2 p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-800 focus:border-transparent"
                                        placeholder={t("EnterLocation") || "Enter location"}
                                        value={formState.legal_awarness_schedules?.[0]?.location || ""}
                                        onChange={(e) => {
                                            setFormState((prev: any) => ({
                                                ...prev,
                                                legal_awarness_schedules: prev.legal_awarness_schedules.map((schedule: any, index: number) => 
                                                    index === 0 ? { ...schedule, location: e.target.value } : schedule
                                                )
                                            }));
                                        }}
                                        required
                                    />
                                </div>
                                <div className="mb-4">
                                    <label className="text-gray-500 font-normal text-sm">
                                        {t("ScheduledDateTime") || "Scheduled Date and Time"}
                                    </label>
                                    <input
                                        type="datetime-local"
                                        name="scheduled_datetime"
                                        className="w-full mt-2 p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-800 focus:border-transparent"
                                        value={formState.legal_awarness_schedules?.[0]?.scheduled_datetime ? 
                                            new Date(formState.legal_awarness_schedules[0].scheduled_datetime).toISOString().slice(0, 16) : ""
                                        }
                                        onChange={(e) => {
                                            setFormState((prev: any) => ({
                                                ...prev,
                                                legal_awarness_schedules: prev.legal_awarness_schedules.map((schedule: any, index: number) => 
                                                    index === 0 ? { ...schedule, scheduled_datetime: e.target.value } : schedule
                                                )
                                            }));
                                        }}
                                        required
                                    />
                                </div>
                                <div className="flex">
                                    <button onClick={handleUpdateSchedule} className="flex-1 p-4 rounded-lg bg-[#0A1D39] hover:bg-[#13294d] text-white font-semibold text-base">
                                        {t("UpdateSchedule") || "Update Schedule"}
                                    </button>
                                </div>
                            </div>
                        )}
                        </div>
                    </div>}
                
                <div className="flex-1 overflow-y-scroll scrollbar-hide">
                    {/* Documents */}
                    <div className="p-6 rounded-xl shadow-xl hover:shadow-2xl transition-shadow duration-300 mb-4 border border-gray-200">
                        <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                            <svg className="w-6 h-6 mr-3 text-red-800" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                            </svg>
                            {t("RequestDetails") || "Request Details"}
                        </h3>
                        <div className="space-y-4">
                            <div className="border border-gray-300 p-4 rounded-lg shadow-sm">
                                <div className="flex items-center">
                                    <label className="w-32 text-[#432101AB] font-medium text-sm">{t("AppliedDate") || "Applied Date"}:</label>
                                    <p className="text-[#0A1D39] font-semibold text-base ml-8">{formatDate(formState?.created_at)}</p>
                                </div>
                            </div>
                            <div className="border border-gray-300 p-4 rounded-lg shadow-sm">
                                <div className="flex items-center">
                                    <label className="w-32 text-[#432101AB] font-medium text-sm">{t("Topics") || "Topics"}:</label>
                                    <p className="text-[#0A1D39] font-semibold text-base ml-8">{formState?.topic}</p>
                                </div>
                            </div>
                            <div className="border border-gray-300 p-4 rounded-lg shadow-sm">
                                <div className="flex items-center">
                                    <label className="w-32 text-[#432101AB] font-medium text-sm">{t("TargetAudience") || "Target Audience"}:</label>
                                    <p className="text-[#0A1D39] font-semibold text-base ml-8">{formState?.target_audience}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    
                    {formState?.outcome_of_awareness &&
                        <div className="mt-6 space-y-4 border border-gray-400 p-4 mb-8 rounded-lg">
                            <p className="text-[#432101AB] mb-2">
                                {t("AwarenessOutcome") || "Awareness Outcome"}
                            </p>
                            {formState?.documents?.find((document: any) => document.document_type === "outcome_of_awareness_file") &&
                                <DocumentViewerModal
                                    documents={formState?.documents.filter((document: any) => document.document_type === "outcome_of_awareness_file")}
                                    baseUrl={`${process.env.REACT_APP_API_BASE_URL}legal_awareness/legal-awareness-documents/document`}
                                />
                            }
                            <div className="mb-8">
                                <div className="flex gap-2">
                                    <p className="text-[#432101AB] font-normal text-base">{t("AwarenessOutcomeSummary") || "Awareness Outcome Summary"}</p>
                                </div>
                                <p className="text-gray-500 font-medium mb-2">
                                    {formState?.outcome_of_awareness}
                                </p>
                            </div>
                        </div>
                    }

                    {/* Upload Legal Awareness Summary / Awareness Outcome — placed with the Summary section */}
                    <ShowUI
                        ui_key={LEGISLATIVE_DRAFTING_UI_RULES.draft_and_additional_file.value}
                        currentStatus={formState.current_approval_status}
                        forwardStatus={formState.forward_status}
                    >
                        <ProsecutorRemark setFormState={setFormState} formState={formState} />
                    </ShowUI>

                    {formState?.summary &&
                        <div className="mt-6 space-y-4 border border-gray-400 p-4 mb-8 rounded-lg">
                            <div className="flex items-center justify-between mb-4">
                                <div className="flex gap-2">
                                    <p className="text-[#432101AB] font-normal text-base">{t("LegalAwarenessSummary") || "Legal Awareness Summary"}</p>
                                </div>
                                <ShowUI
                                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.approve_or_respond.value}
                                    currentStatus={formState.current_approval_status}
                                    forwardStatus={formState.forward_status}
                                >
                                    <div onClick={() => setEdit(!edit)} className="px-2 hover:bg-gray-100 rounded-lg cursor-pointer">
                                        {edit ?
                                            <p className="text-sm text-blue-600">{t("Cancel") || "Cancel"}</p> :
                                            <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.66406 21V16.75L16.8641 3.575C17.0641 3.39167 17.2851 3.25 17.5271 3.15C17.7691 3.05 18.0231 3 18.2891 3C18.5551 3 18.8134 3.05 19.0641 3.15C19.3147 3.25 19.5314 3.4 19.7141 3.6L21.0891 5C21.2891 5.18333 21.4351 5.4 21.5271 5.65C21.6191 5.9 21.6647 6.15 21.6641 6.4C21.6641 6.66667 21.6184 6.921 21.5271 7.163C21.4357 7.405 21.2897 7.62567 21.0891 7.825L7.91406 21H3.66406ZM18.2641 7.8L19.6641 6.4L18.2641 5L16.8641 6.4L18.2641 7.8Z" fill="black" transform="scale(0.9) translate(-1, -1)" />
                                            </svg>
                                        }
                                    </div>
                                </ShowUI>
                            </div>
                            
                            {/* Edit form for summary and document upload */}
                            {edit && (
                                <ShowUI
                                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.approve_or_respond.value}
                                    currentStatus={formState.current_approval_status}
                                    forwardStatus={formState.forward_status}
                                >
                                    <div className="mb-4">
                                        <label className="text-gray-500 font-normal text-sm">
                                            {t("Summary") || "Summary"}
                                        </label>
                                        <textarea
                                            id="summary"
                                            name="summary"
                                            className="w-full mt-2 p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-800 focus:border-transparent resize-y min-h-[100px]"
                                            placeholder={t("DetailHere") || "detail here..."}
                                            value={formState?.summary}
                                            onChange={handleChange}
                                            required
                                        ></textarea>
                                        <div className="mb-4 mt-4">
                                            <label className="text-gray-500 font-normal text-sm">
                                                {t("LegalAwarenessDocumentFile") || "Legal Awareness Document File"}
                                            </label>
                                            <DynamicFormInput
                                                inputs={[
                                                    {
                                                        type: "file",
                                                        label: t("LegalAwarenessDocument") || "Legal Awareness Document",
                                                        name: "legal_awareness_document_file",
                                                        onChange: (file) => handleFileChange(file, "legal_awareness_document_file"),
                                                    },
                                                ]}
                                            />
                                        </div>
                                        <div className="flex">
                                            <button onClick={handleUpdateSummary} className="flex-1 border border-black p-4 rounded-lg bg-[#D4D4D4] text-[#212121] font-semibold text-base">
                                                {t("UpdateSummary") || "Update Summary"}
                                            </button>
                                        </div>
                                    </div>
                                </ShowUI>
                            )}
                            
                            {/* Show latest legal awareness document file independently */}
                            {!edit && (() => {
                                const legalAwarenessDocuments = formState?.documents?.filter((document: any) => document.document_type === "legal_awareness_document_file") || [];
                                if (legalAwarenessDocuments.length > 0) {
                                    const latestDocument = legalAwarenessDocuments[legalAwarenessDocuments.length - 1];
                                    const previousDocuments = legalAwarenessDocuments.slice(0, -1);
                                    
                                    return (
                                        <>
                                            <div className="mb-4">
                                                <p className="text-sm text-gray-500 mb-2">{t("LatestDocument") || "Latest Document"}:</p>
                                                <DocumentViewerModal
                                                    documents={[latestDocument]}
                                                    baseUrl={`${process.env.REACT_APP_API_BASE_URL}legal_awareness/legal-awareness-documents/document`}
                                                />
                                            </div>
                                            
                                            {previousDocuments.length > 0 && (
                                                <div className="border border-gray-200 rounded-lg">
                                                    <div className="flex justify-between items-center p-3 bg-gray-50 rounded-t-lg cursor-pointer" onClick={() => setShowDraftHistory(!showDraftHistory)}>
                                                        <p className="text-sm font-medium text-gray-700">{t("PreviousDocuments", { count: previousDocuments.length }) || `Previous Documents (${previousDocuments.length})`}</p>
                                                        <svg className={`w-4 h-4 transition-transform ${showDraftHistory ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                                        </svg>
                                                    </div>
                                                    {showDraftHistory && (
                                                        <div className="p-3 space-y-2">
                                                            {previousDocuments.map((doc: any, index: number) => (
                                                                <div key={doc.id} className="border border-gray-100 rounded p-2">
                                                                    <p className="text-xs text-gray-500 mb-1">{t("Version") || "Version"} {previousDocuments.length - index}</p>
                                                                    <DocumentViewerModal
                                                                        documents={[doc]}
                                                                        baseUrl={`${process.env.REACT_APP_API_BASE_URL}legal_awareness/legal-awareness-documents/document`}
                                                                    />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </>
                                    );
                                }
                                return null;
                            })()}
                            
                            {!edit && (
                                <div className="mb-8">
                                    <p className="text-gray-500 font-medium mb-2">
                                        {formState?.summary}
                                    </p>
                                </div>
                            )}
                        </div>
                    }
                    
                    {formState?.distrbuted_to_zone?.length > 0 && (
                        <div className="mt-6 mb-3">
                            <div className="flex items-center gap-2">
                                <svg className="w-5 h-5 text-[#0A1D39]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
                                </svg>
                                <p className="text-[10px] uppercase tracking-widest text-[#9B0505] font-semibold">{t("OAG") || "OAG"}</p>
                            </div>
                            <p className="text-base font-semibold text-[#0A1D39]">{t("DistributedToZones") || "Distributed to Zones"}</p>
                            <p className="text-xs text-gray-500">
                                {t("DistributedToZonesHint") || "This awareness program has been distributed to the zones below. Select a zone to view its awareness report and submitted documents."}
                            </p>
                        </div>
                    )}

                    {formState?.distrbuted_to_zone?.length > 0 && (
                        <TabNav
                            active={activeTab}
                            tabs={formState.distrbuted_to_zone.map((zone: any) => ({ name: zone.admin_unit_name, submitted: !!zone.report_summary }))}
                            onSelect={setActiveTab}
                        />
                    )}
                    
                    {formState?.distrbuted_to_zone?.length > 0 && (() => {
                        const zoneFile = formState?.distrbuted_to_zone?.find((zone: any) => zone.admin_unit_name === activeTab);
                        const isReportSubmitted = !!zoneFile?.report_summary;
                        return (
                            <div className="mt-6 space-y-4 border border-gray-300 p-6 mb-8 rounded-xl bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 shadow-xl hover:shadow-2xl transition-shadow duration-300">
                                <div className="flex items-center justify-between mb-6">
                                    <h3 className="text-xl font-bold text-gray-900 flex items-center">
                                        <svg className="w-6 h-6 mr-3 text-red-800" fill="currentColor" viewBox="0 0 20 20">
                                            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                                        </svg>
                                        {t("AwarenessReportFor", { zone: activeTab }) || `Awareness Report for ${activeTab}`}
                                    </h3>
                                    <div className={`flex items-center px-4 py-2 rounded-full text-sm font-semibold shadow-md ${isReportSubmitted ? 'bg-green-200 text-green-900 border border-green-300' : 'bg-red-200 text-red-900 border border-red-300'}`}>
                                        {isReportSubmitted ? (
                                            <>
                                                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                                </svg>
                                                {t("Submitted") || "Submitted"}
                                            </>
                                        ) : (
                                            <>
                                                <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                                </svg>
                                                {t("NotSubmitted") || "Not Submitted"}
                                            </>
                                        )}
                                    </div>
                                </div>
                                {isReportSubmitted ? (
                                    <>
                                        <div className="bg-white p-5 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200">
                                            <p className="text-[#432101AB] font-semibold text-lg mb-3">{t("AwarenessReportSummary") || "Awareness Report Summary"}</p>
                                            <p className="text-gray-800 font-medium leading-relaxed">
                                                {zoneFile?.report_summary}
                                            </p>
                                        </div>
                                        {zoneFile?.documents?.find((document: any) => document.document_type === "distrbuted_zone_report") &&
                                            <div className="bg-white p-5 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200">
                                                <DocumentViewerModal
                                                    documents={zoneFile?.documents.filter((document: any) => document.document_type === "distrbuted_zone_report")}
                                                    baseUrl={`${process.env.REACT_APP_API_BASE_URL}legal_awareness/legal-awareness-documents/document`}
                                                />
                                            </div>
                                        }
                                    </>
                                ) : (
                                    <div className="bg-gradient-to-br from-red-100 to-orange-100 p-8 rounded-lg shadow-lg text-center border-2 border-dashed border-red-400 hover:shadow-xl transition-shadow duration-300 animate-pulse">
                                        <svg className="w-20 h-20 mx-auto text-red-600 mb-6 animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                        </svg>
                                        <p className="text-red-800 text-2xl font-bold mb-3">{t("ReportNotSubmittedYet") || "Report Not Submitted Yet"}</p>
                                        <p className="text-red-600 text-lg">{t("AwarenessReportNotUploadedMessage") || "The awareness report for this zone has not been uploaded. Please check back later or contact the relevant team."}</p>
                                    </div>
                                )}
                            </div>
                        );
                    })()}
                    
                    {formState?.teams &&
                        formState?.teams?.length !== 0 &&
                        (<div className="mt-6 mb-6 flex bg-gray-50 rounded-lg border border-gray-200">
                            <ActionAvatars
                                title={t("TeamList") || "Team List"}
                                users={formState?.teams}
                                prosecutor={true}
                            />
                            {(contextData?.user?.roles?.some((p: string) => p === "LRDIFUDDirector") ||
                                contextData?.user?.roles?.some((p: string) => p === "LegalResearchCoordinator")) && (
                                <button
                                    type="button"
                                    onClick={() => setEditTeamOpen(true)}
                                    className="ml-auto my-auto mr-2 bg-[#0A1D39] hover:bg-[#13294d] text-white px-3 py-1.5 rounded text-sm font-semibold"
                                >{t("EditTeam") || "Edit Team"}</button>
                            )}
                            <svg onClick={() => setViewTeam(!viewTeam)} className="mr-2 my-auto cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <mask id="mask0_9_31087" maskUnits="userSpaceOnUse" x="1" y="5" width="22" height="14">
                                    <path d="M12 18C17.523 18 22 12 22 12C22 12 17.523 6 12 6C6.477 6 2 12 2 12C2 12 6.477 18 12 18Z" fill="white" stroke="white" strokeWidth="1.33333" strokeLinejoin="round" />
                                    <path d="M12 14.5C12.663 14.5 13.2989 14.2366 13.7678 13.7678C14.2366 13.2989 14.5 12.663 14.5 12C14.5 11.337 14.2366 10.7011 13.7678 10.2322C13.2989 9.76339 12.663 9.5 12 9.5C11.337 9.5 10.7011 9.76339 10.2322 10.2322C9.76339 10.7011 9.5 11.337 9.5 12C9.5 12.663 9.76339 13.2989 10.2322 13.7678C10.7011 14.2366 11.337 14.5 12 14.5Z" fill="black" stroke="black" strokeWidth="1.33333" strokeLinejoin="round" />
                                </mask>
                                <g mask="url(#mask0_9_31087)">
                                    <path d="M0 0H24V24H0V0Z" fill="#EFC83D" />
                                </g>
                            </svg>
                        </div>)}
                    <br />
                    
                    <ShowUI
                        ui_key={LEGISLATIVE_DRAFTING_UI_RULES.approve_or_respond.value}
                        currentStatus={formState.current_approval_status}
                        forwardStatus={formState.forward_status}
                    >
                        <LegislativeRespondBackForm
                            request={formState}
                            setLegalResearch={setFormState}
                            isOpen={isRespondBackFormOpen}
                            onClose={() => setIsRespondBackFormOpen(false)}
                            forward={LEGAL_ADVISORY_REQUEST_STATUS.assigned_to_prosecutor.value}
                            type="legal"
                        />
                        <div className="mt-4 pb-8 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center gap-3">
                            <button
                                type="button"
                                className="inline-flex flex-1 items-center justify-center gap-2 px-5 py-2.5 rounded-lg border border-gray-300 text-gray-700 text-sm font-semibold hover:bg-gray-50 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-300 transition-colors disabled:opacity-50"
                                onClick={handleRespondBackClick}
                                disabled={loading}
                            >
                                {loading ? (
                                    <>{LoadingIcon} {t("Submitting") || "Submitting..."}</>
                                ) : (
                                    <>
                                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 10h10a5 5 0 015 5v2m-15-7l4-4m-4 4l4 4" />
                                        </svg>
                                        {t("RespondBack") || "Respond back"}
                                    </>
                                )}
                            </button>
                            <button
                                type="button"
                                onClick={() => handleForwardClick(LEGAL_AWAERENESS_REQUEST_STATUS.summary_approved.value)}
                                disabled={loading}
                                className="inline-flex flex-1 items-center justify-center gap-2 px-5 py-2.5 rounded-lg bg-[#0A1D39] text-white text-sm font-semibold shadow-sm hover:bg-[#13294d] focus:outline-none focus:ring-2 focus:ring-[#0A1D39]/40 transition-colors disabled:opacity-50"
                            >
                                {loading ? (
                                    <>{LoadingIcon} {t("Submitting") || "Submitting..."}</>
                                ) : (
                                    <>
                                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                        </svg>
                                        {t("Approve") || "Approve"}
                                    </>
                                )}
                            </button>
                        </div>
                    </ShowUI>
                    
                    {/* Remark Section */}
                    <ShowUI
                        ui_key={LEGISLATIVE_DRAFTING_UI_RULES.internal_ui.value}
                        currentStatus={"all"}
                        forwardStatus={"all"}
                    >
                        {formState.remarks && formState?.remarks?.find((remark: any) => remark.role === "head") &&
                            <div>
                                <p className="text-[#432101AB] font-normal text-base">{t("RemarkForDirector") || "Remark For Director"}</p>
                                <p className="text-gray-500 font-medium mb-2">
                                    {formState?.remarks.filter((remark: any) => remark.role === "head").slice().reverse()[0]?.remark}
                                </p>
                                <br />
                            </div>
                        }
                        {formState.remarks && formState?.remarks?.find((remark: any) => remark.role === "director") &&
                            <div>
                                <p className="text-[#432101AB] font-normal text-base">{t("RemarkForCoordinator") || "Remark For Coordinator"}</p>
                                <p className="text-gray-500 font-medium mb-2">
                                    {formState?.remarks.filter((remark: any) => remark.role === "director").slice().reverse()[0]?.remark}
                                </p>
                                <br />
                            </div>
                        }
                        {formState.remarks && formState?.remarks?.find((remark: any) => remark.role === "coordinator") &&
                            <div>
                                <p className="text-[#432101AB] font-normal text-base">{t("RemarkForProsecutor") || "Remark For Prosecutor"}</p>
                                <p className="text-gray-500 font-medium mb-2">
                                    {formState?.remarks.filter((remark: any) => remark.role === "coordinator").slice().reverse()[0]?.remark}
                                </p>
                                <br />
                            </div>
                        }
                    </ShowUI>
                </div>
                
                <ShowUI
                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.approve_or_schedule.value}
                    currentStatus={formState.current_approval_status}
                    forwardStatus={formState.forward_status}
                >
                    <CoordinatorRemark setFormState={setFormState} formState={formState} />
                </ShowUI>
            </div>
            
            {/* Modals */}
            {publicFeedback &&
                (<PublicFeedback
                    data={formState}
                    setLegalResearch={setFormState}
                    isOpen={publicFeedback}
                    onClose={() => setPublicFeedback(false)}
                />)
            }
            {uploadAmend &&
                (<UploadAmendedFile
                    data={formState}
                    setLegalResearch={setFormState}
                    isOpen={uploadAmend}
                    onClose={() => setUploadAmend(false)}
                />)
            }
            {viewTeam &&
                <TeamView teamMembers={formState.teams} onClose={() => setViewTeam(false)} />
            }

            <EditTeamModal
                request={formState}
                isOpen={editTeamOpen}
                onClose={() => setEditTeamOpen(false)}
                setFormState={setFormState}
            />

            <ConfirmationModal
                isOpen={confirmationModalOpen}
                isLoading={loading}
                onConfirm={handleConfirmForward}
                onCancel={() => setConfirmationModalOpen(false)}
                title={t("ConfirmAction") || "Confirm Action"}
                message={t("ConfirmActionMessage") || "Please review all entered information carefully. Once confirmed, this action will be submitted and cannot be modified."}
                confirmText={t("Confirm") || "Confirm"}
                cancelText={t("Cancel") || "Cancel"}
                type="success"
            />
        </div>
    );
}

export default LegalAwarenessCreationDetail;